import { Link } from "react-router-dom";
import { Eye, Heart, MessageSquare } from "lucide-react";
import { resolveThumbUrl } from "../lib/api";
import { localizedTitle } from "../lib/photoI18n";
import { useLang } from "../contexts/LanguageContext";

export default function PhotoCard({ photo, index = 0 }) {
  const { t, lang } = useLang();
  const src = resolveThumbUrl(photo);
  const title = localizedTitle(photo, lang);
  return (
    <Link
      to={`/photo/${photo.id}`}
      className="group block mb-4 sm:mb-6 break-inside-avoid border border-zinc-900 hover:border-zinc-700 transition-colors"
      data-testid={`feed-photo-card-${photo.id}`}
      style={{ animationDelay: `${Math.min(index * 40, 600)}ms` }}
    >
      <div className="relative overflow-hidden bg-zinc-900">
        <img
          src={src}
          alt={title}
          loading="lazy"
          className="w-full h-auto block transition-transform duration-700 ease-out group-hover:scale-[1.03]"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-zinc-950/85 via-zinc-950/10 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
        <div className="absolute bottom-0 left-0 right-0 p-5 translate-y-2 opacity-0 group-hover:opacity-100 group-hover:translate-y-0 transition-all duration-500">
          <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-zinc-400">
            {t("by_artist")}
          </div>
          <div className="font-serif text-xl text-zinc-50 font-light mt-1">
            {photo.user_name}
          </div>
          <div className="mt-2 font-sans text-sm text-zinc-300 font-light line-clamp-1">
            {title}
          </div>
        </div>
      </div>
      <div className="flex items-center justify-between px-4 py-3 bg-zinc-950 gap-3">
        <div className="font-serif text-base text-zinc-100 font-light truncate">
          {title}
        </div>
        <div
          className="flex items-center gap-3 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500 shrink-0"
          data-testid={`feed-photo-stats-${photo.id}`}
        >
          <span className="inline-flex items-center gap-1" title={t("stats_views")}>
            <Eye size={10} />
            {photo.views ?? 0}
          </span>
          <span className="inline-flex items-center gap-1" title={t("appreciate")}>
            <Heart size={10} />
            {photo.appreciations ?? 0}
          </span>
          <span className="inline-flex items-center gap-1" title={t("comments")}>
            <MessageSquare size={10} />
            {photo.comments_count ?? 0}
          </span>
        </div>
      </div>
    </Link>
  );
}
